export enum DashboardTypeEnum {
  RegisteredSign = 'REGISTERED_SIGN',
  Expenditure = 'EXPENDITURE',
  Contract = 'CONTRACT',
  RegisteredSignYear = 'REGISTERED_SIGN_YEAR',
  Organization = 'ORGANIZATION',
  ContractInvestment = 'CONTRACT_INVESTMENT',
  Inventory = 'INVENTORY',
  Paths = 'PATHS',
  RetroAlert = 'RETRO_ALERT',
  Team = 'TEAM',
  Vehicle = 'VEHICLE',
  ServiceOrder = 'SERVICE_ORDER',
  Task = 'TASK',
  Project = 'PROJECT',
  Catalog = 'CATALOG',
  Pendency = 'PENDENCY',
  Region = 'REGION',
  Area = 'AREA'
}
